var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 9.25C4.2875 9.25 3.5 10.0375 3.5 11C3.5 11.9625 4.2875 12.75 5.25 12.75C6.2125 12.75 7 11.9625 7 11C7 10.0375 6.2125 9.25 5.25 9.25ZM15.75 9.25C14.7875 9.25 14 10.0375 14 11C14 11.9625 14.7875 12.75 15.75 12.75C16.7125 12.75 17.5 11.9625 17.5 11C17.5 10.0375 16.7125 9.25 15.75 9.25ZM10.5 9.25C9.5375 9.25 8.75 10.0375 8.75 11C8.75 11.9625 9.5375 12.75 10.5 12.75C11.4625 12.75 12.25 11.9625 12.25 11C12.25 10.0375 11.4625 9.25 10.5 9.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three-dots.979af25c2a7ec240e5f0ee2195e77e10.svg";
export { ForwardRef as ReactComponent };